import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const company_complements = ref([])
const company_complement_filters = ref({})
const filtered_company_complements = ref([])

export default function useCompanyComplements() {
  const listCompanyComplements = async (company_id) => {
    await axios
      .get('/api/company_complements/all', {
        params: { company_id: company_id },
      })
      .then(function (response) {
        company_complements.value = filtered_company_complements.value =
          response.data.data
      })
      .catch(function () {})
  }

  const listCompanyComplementsByArea = async (area_id) => {
    await axios
      .get('/api/company_complements/all-by-area', {
        params: { company_area_id: area_id },
      })
      .then(function (response) {
        company_complements.value = filtered_company_complements.value =
          response.data.data
      })
      .catch(function () {})
  }

  const updateCompanyComplementFilters = async () => {
    let filters = toRaw(company_complement_filters.value)

    filtered_company_complements.value = company_complements.value.filter(
      (row) => {
        let company_complement = toRaw(row)
        let matches = 0

        for (let key of Object.keys(filters)) {
          if (filters[key].toString().trim() == '') {
            matches++
            continue
          }

          if (
            company_complement[key]
              .toString()
              .trim()
              .toLowerCase()
              .normalize('NFD')
              .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
              .includes(
                filters[key]
                  .toString()
                  .trim()
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
              )
          ) {
            matches++
          }
        }

        return matches == Object.keys(filters).length
      },
    )
  }

  const clearFilteredCompanyComplements = () => {
    filtered_company_complements.value = []
  }

  watch(company_complement_filters.value, () => {
    updateCompanyComplementFilters()
  })

  return {
    company_complements: computed(() => company_complements.value),
    filtered_company_complements: computed(
      () => filtered_company_complements.value,
    ),
    company_complement_filters: company_complement_filters,
    listCompanyComplements,
    listCompanyComplementsByArea,
    clearFilteredCompanyComplements,
  }
}
